'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var redux = require('redux');
var fetch$1 = require('@ekultur/fetch');
var React = require('react');
var reactRedux = require('react-redux');
var reactRouterDom = require('react-router-dom');
var querystring = require('querystring');
var appHeader = require('@ekultur/app-header');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var USERDATA_REQUESTED = 'userdata/requested';
var USERDATA_RECEIVED = 'userdata/received';
var USERDATA_FAILED = 'userdata/failed';
var fetchUserdataPromise = function fetchUserdataPromise(dispatch) {
  dispatch(requestUserdata());
  return fetch$1.kitFetch("/authz/authorize/userData");
};
var requestUserdata = function requestUserdata() {
  return {
    type: USERDATA_REQUESTED
  };
};
var receiveUserdata = function receiveUserdata(userdata, museums, apps) {
  return {
    type: USERDATA_RECEIVED,
    userdata: {
      name: userdata.name,
      uniqueId: userdata.uniqueId,
      imageUrl: userdata.imageUrl,
      initials: userdata.initials,
      email: userdata.email,
      theme: {
        primaryColor: "#d94353",
        lightColor: "#ee7e8f",
        darkColor: "#ae3552"
      }
    },
    apps: userdata.appAccess.apps.map(function (app) {
      return _objectSpread2(_objectSpread2({}, app), {}, {
        title: apps[app.id].title,
        url: apps[app.id].url,
        icon: apps[app.id].icon_url ? null : apps[app.id].icon,
        imageUrl: apps[app.id].icon_url,
        theme: {
          primaryColor: apps[app.id].theme.primary_color,
          lightColor: apps[app.id].theme.light_color,
          darkColor: apps[app.id].theme.dark_color
        }
      });
    }),
    museums: userdata.appAccess.museums.map(function (museum) {
      return {
        title: museums[museum.id] ? museums[museum.id].name : 'Museum name missing',
        uniqueId: museum.id.toString(),
        imageUrl: "https://".concat(museums[museum.id].media),
        media: museums[museum.id].media,
        name: museums[museum.id] ? museums[museum.id].name : 'N/A',
        abbr: museums[museum.id].short_name || 'N/A',
        createdAt: museums[museum.id].created,
        url: "/?museum_id=".concat(museum.id.toString()),
        theme: {
          primaryColor: museums[museum.id].primary_color || "#d94353",
          lightColor: museums[museum.id].light_color || "#ee7e8f",
          darkColor: museums[museum.id].dark_color || "#ae3552"
        },
        apps: museum.applications.map(function (app) {
          return _objectSpread2(_objectSpread2({}, app), {}, {
            title: apps[app.id].title,
            url: "".concat(apps[app.id].url, "?museum_id=").concat(museum.id),
            icon: apps[app.id].icon_url ? null : apps[app.id].icon,
            imageUrl: apps[app.id].icon_url,
            theme: {
              primaryColor: apps[app.id].theme.primary_color,
              lightColor: apps[app.id].theme.light_color,
              darkColor: apps[app.id].theme.dark_color
            }
          });
        }),
        type: museums[museum.id].type
      };
    })
  };
};
var resetUserdata = function resetUserdata() {
  return {
    type: USERDATA_FAILED,
    userdata: {},
    apps: [],
    museums: []
  };
};

function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys$1(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys$1(Object(source), true).forEach(function (key) {
        _defineProperty$1(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$1(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var itemsById = function itemsById(items) {
  return {
    items: items.reduce(function (accumulator, item) {
      return _objectSpread2$1(_objectSpread2$1({}, accumulator), {}, _defineProperty$1({}, item.id, item));
    }, {})
  };
};

var MUSEUMS_REQUESTED = 'museums/requested';
var MUSEUMS_RECEIVED = 'museums/received';
var MUSEUMS_FAILED = 'museums/failed';
var fetchMuseums = function fetchMuseums() {
  return function (dispatch) {
    fetchMuseumsPromise(dispatch).then(function (json) {
      var museumsById = itemsById(json.museums).items;
      dispatch(receiveMuseums(museumsById, json.museums));
    })["catch"](function () {
      return dispatch(failMuseums());
    });
  };
};
var fetchMuseumsPromise = function fetchMuseumsPromise(dispatch) {
  dispatch(requestMuseums());
  return fetch$1.kitFetch("/museum-api/museums");
};
var requestMuseums = function requestMuseums() {
  return {
    type: MUSEUMS_REQUESTED
  };
};
var receiveMuseums = function receiveMuseums(museumsById, museumsList) {
  return {
    type: MUSEUMS_RECEIVED,
    museums: museumsById,
    museumsList: museumsList,
    allIds: Object.keys(museumsById)
  };
};
var failMuseums = function failMuseums() {
  return {
    type: MUSEUMS_FAILED
  };
};

var APPLICATIONS_REQUESTED = 'apps/requested';
var APPLICATIONS_RECEIVED = 'apps/received';
var APP_RECEIVED = 'apps/appReceived';
var APP_INFO_SET = 'apps/appInfoSet';
var fetchApplications = function fetchApplications() {
  return function (dispatch) {
    fetchApplicationsPromise(dispatch).then(function (applications) {
      var applicationsById = itemsById(applications).items;
      dispatch(applicationsReceived(applicationsById, applications));
    });
  };
};
var fetchApplicationsPromise = function fetchApplicationsPromise(dispatch) {
  dispatch(applicationsRequested());
  return fetch$1.kitFetch("/app-registry/apps/");
};
var fetchApplication = function fetchApplication(appId) {
  return function (dispatch) {
    fetch$1.kitFetch("/app-registry/apps/".concat(appId, "/")).then(function (application) {
      dispatch(appReceived(application));
    });
  };
};
var applicationsRequested = function applicationsRequested() {
  return {
    type: APPLICATIONS_REQUESTED
  };
};
var applicationsReceived = function applicationsReceived(applicationsById, applicationsList) {
  return {
    type: APPLICATIONS_RECEIVED,
    applications: applicationsById,
    allIds: Object.keys(applicationsById),
    applicationsList: applicationsList
  };
};

var appReceived = function appReceived(app) {
  return {
    type: APP_RECEIVED,
    title: app.title,
    theme: {
      primaryColor: app.theme.primary_color,
      lightColor: app.theme.light_color,
      darkColor: app.theme.dark_color
    },
    imageUrl: app.icon_url
  };
};

var setAppInfo = function setAppInfo(app) {
  return function (dispatch) {
    dispatch({
      type: APP_INFO_SET,
      app: app
    });
  };
};

var AUTHZ_DATA_RECEIVED = 'authz/dataReceived';
var receiveGlobalApp = function receiveGlobalApp(app) {
  return {
    type: AUTHZ_DATA_RECEIVED,
    isAdmin: app.role.name === 'Admin'
  };
};
var receiveMuseumApp = function receiveMuseumApp() {
  return {
    type: AUTHZ_DATA_RECEIVED,
    isAdmin: false
  };
};

var APPS_NAV_DATA_REQUESTED = 'appsNav/dataRequested';
var OWNER_SELECTED_BY_ID = 'appsNav/ownerSelectedById';
var fetchAppsNavData = function fetchAppsNavData(appId) {
  return function (dispatch) {
    dispatch(appsNavDataRequested());
    Promise.all([fetchMuseumsPromise(dispatch)["catch"](function (error) {
      return {
        error: error,
        code: error
      };
    }), fetchApplicationsPromise(dispatch), fetchUserdataPromise(dispatch)["catch"](function (error) {
      return {
        error: error,
        code: error
      };
    })]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          museumsJson = _ref2[0],
          appsJson = _ref2[1],
          userdataJson = _ref2[2];

      if (museumsJson.hasOwnProperty('error')) {
        dispatch(failMuseums());
        return;
      }

      if (userdataJson.hasOwnProperty('error')) {
        if (401 === userdataJson.code) {
          dispatch(resetUserdata());
        }

        return;
      }

      var museumsById = itemsById(museumsJson.museums).items;
      dispatch(receiveMuseums(museumsById, museumsJson.museums));
      var applicationsById = itemsById(appsJson).items;
      dispatch(applicationsReceived(applicationsById, appsJson));
      dispatch(receiveUserdata(userdataJson, museumsById, applicationsById));

      if (appId) {
        var globalAppAccess = userdataJson.appAccess.apps.filter(function (app) {
          return app.id === appId;
        });
        var museumAppAccess = userdataJson.appAccess.museums.filter(function (museum) {
          return museum.applications.filter(function (app) {
            return function (app) {
              return app.id === appId;
            };
          });
        });

        if (globalAppAccess[0]) {
          dispatch(receiveGlobalApp(globalAppAccess[0]));
        } else if (museumAppAccess[0]) {
          dispatch(receiveMuseumApp());
        }
      }
    })["catch"](function (error) {
      console.log(error);
    });
  };
};

var appsNavDataRequested = function appsNavDataRequested() {
  return {
    type: APPS_NAV_DATA_REQUESTED
  };
};

var selectOwnerById = function selectOwnerById(ownerId) {
  return function (dispatch) {
    dispatch({
      type: OWNER_SELECTED_BY_ID,
      ownerId: ownerId
    });
  };
};

var getState = function getState() {
  return sessionStorage.getItem('state');
};
var setState = function setState(state) {
  return sessionStorage.setItem('state', state);
};
var getPreviousPath = function getPreviousPath() {
  return sessionStorage.getItem('previousPath');
};
var setPreviousPath = function setPreviousPath(previousPath) {
  return sessionStorage.setItem('previousPath', previousPath);
};
var getRedirectUri = function getRedirectUri() {
  var url = "".concat(window.location.protocol, "//").concat(window.location.hostname);

  if (window.location.port) {
    url = "".concat(url, ":").concat(window.location.port);
  }

  return "".concat(url, "/oauth2/callback");
};
var cleanStorage = function cleanStorage() {
  sessionStorage.removeItem('state');
  sessionStorage.removeItem('previousPath');
};

// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

var REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

function validate(uuid) {
  return typeof uuid === 'string' && REGEX.test(uuid);
}

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0; // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434

  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return stringify(rnds);
}

var USER_LOGIN_STARTED = 'auths/loginStarted';
var USER_LOGGED_IN = "auths/loggedIn";
var USER_LOGGED_OUT = 'auths/loggedOut';
var logIn = function logIn(token, expires_in) {
  return function (dispatch) {
    dispatch({
      type: USER_LOGIN_STARTED
    });
    localStorage.setItem('kit.access_token', token);
    var futureRefresh = setTimeout(function () {
      dispatch(refreshToken());
    }, expires_in * 1000 - 60000);
    dispatch(loggedIn(futureRefresh));
  };
};
var refreshToken = function refreshToken() {
  return function (dispatch) {
    dispatch({
      type: USER_LOGIN_STARTED
    });
    var data = new URLSearchParams();
    data.append('grant_type', 'refresh_token');
    data.append('redirect_uri', getRedirectUri());
    fetch("".concat(getApigateway(), "/auths/oauth2/token"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Correlation-Id': v4()
      },
      credentials: 'include',
      body: data
    }).then(function (response) {
      if (response.ok) {
        return response.json();
      } else {
        throw new Error(response.statusText);
      }
    }).then(function (data) {
      dispatch(logIn(data.access_token, data.expires_in));
    })["catch"](function (error) {
      console.log(error);
      dispatch(logOut());
    });
  };
};

var getApigateway = function getApigateway() {
  if (window._env_ && window._env_.REACT_APP_API_GATEWAY) {
    return window._env_.REACT_APP_API_GATEWAY;
  } else {
    return process.env.REACT_APP_API_GATEWAY;
  }
};

var logOut = function logOut() {
  return function (dispatch) {
    localStorage.removeItem('kit.access_token');
    localStorage.removeItem('kit.expires');
    dispatch({
      type: USER_LOGGED_OUT
    });
  };
};

var loggedIn = function loggedIn(futureRefresh) {
  return {
    type: USER_LOGGED_IN,
    futureRefresh: futureRefresh
  };
};

var initialState = {
  loginUrl: '/login',
  logoutUrl: '/logout',
  apps: [],
  owners: [],
  ownerUniqueId: null,
  preSelectedOwner: null,
  isFetching: false,
  selectedOwner: null
};

var userReducer = function userReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case APPS_NAV_DATA_REQUESTED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isFetching: true
      });

    case USERDATA_RECEIVED:
      return _objectSpread2(_objectSpread2(_objectSpread2({}, state), action.userdata), {}, {
        apps: action.apps,
        owners: action.museums,
        isFetching: false,
        ownerUniqueId: state.preSelectedOwner,
        selectedOwner: action.museums.find(function (owner) {
          return owner.uniqueId === state.preSelectedOwner;
        })
      });

    case OWNER_SELECTED_BY_ID:
      if (state.owners.length) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          ownerUniqueId: action.ownerId.toString(),
          selectedOwner: state.owners.find(function (owner) {
            return owner.uniqueId === action.ownerId.toString();
          })
        });
      } else {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          preSelectedOwner: action.ownerId.toString()
        });
      }

    case USERDATA_FAILED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isFetching: false
      });

    case USER_LOGGED_OUT:
      return initialState;

    default:
      return state;
  }
};

var initialState$1 = {
  title: '',
  subtitle: 'Ikke innlogget',
  version: null,
  updatedAt: null,
  theme: {
    primaryColor: null,
    lightColor: null,
    darkColor: null
  },
  loaded: false,
  imageUrl: null
};

var appReducer = function appReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case APP_INFO_SET:
      return _objectSpread2(_objectSpread2({}, state), action.app);

    case USERDATA_RECEIVED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        subtitle: action.userdata.name
      });

    case USERDATA_FAILED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        subtitle: initialState$1.subtitle
      });

    case APP_RECEIVED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        title: action.title,
        theme: action.theme,
        loaded: true,
        imageUrl: action.imageUrl
      });

    case USER_LOGGED_OUT:
      return _objectSpread2(_objectSpread2({}, initialState$1), {}, {
        title: state.title,
        version: state.version,
        updatedAt: state.updatedAt,
        theme: state.theme,
        loaded: state.loaded
      });

    default:
      return state;
  }
};

var initialState$2 = {
  isFetching: false,
  items: {},
  allIds: [],
  fetchFailed: false,
  list: []
};

var museumsReducer = function museumsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$2;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case MUSEUMS_REQUESTED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isFetching: true
      });

    case MUSEUMS_RECEIVED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isFetching: false,
        fetchFailed: false,
        items: action.museums,
        allIds: action.allIds,
        list: action.museumsList
      });

    case MUSEUMS_FAILED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isFetching: false,
        fetchFailed: true
      });

    default:
      return state;
  }
};

var initialState$3 = {
  loggedIn: false,
  futureRefresh: null,
  loginInProgress: false
};

var authsReducer = function authsReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$3;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case USER_LOGIN_STARTED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        loginInProgress: true
      });

    case USER_LOGGED_IN:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        loggedIn: true,
        futureRefresh: action.futureRefresh,
        loginInProgress: false
      });

    case USER_LOGGED_OUT:
      if (state.futureRefresh) {
        clearTimeout(state.futureRefresh);
      }

      return _objectSpread2(_objectSpread2({}, state), {}, {
        loggedIn: false,
        futureRefresh: null,
        loginInProgress: false
      });

    default:
      return state;
  }
};

var initialState$4 = {
  isAdmin: false,
  canAccessApp: false
};

var authzReducer = function authzReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$4;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case AUTHZ_DATA_RECEIVED:
      return _objectSpread2(_objectSpread2({}, state), {}, {
        isAdmin: action.isAdmin,
        canAccessApp: true
      });

    default:
      return state;
  }
};

var initialState$5 = {
  uniqueId: null,
  name: null,
  _owners: []
};

var ownerReducer = function ownerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$5;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case OWNER_SELECTED_BY_ID:
      if (state._owners.length) {
        var selectedOwner = state._owners.find(function (owner) {
          return parseInt(owner.uniqueId) === parseInt(action.ownerId);
        });

        return _objectSpread2(_objectSpread2({}, state), {}, {
          uniqueId: action.ownerId,
          name: selectedOwner ? selectedOwner.title : "-"
        });
      } else {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          uniqueId: action.ownerId
        });
      }

    case USERDATA_RECEIVED:
      if (state.uniqueId) {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          _owners: action.museums,
          name: action.museums.find(function (museum) {
            return parseInt(museum.uniqueId) === parseInt(state.uniqueId);
          }).title
        });
      } else {
        return _objectSpread2(_objectSpread2({}, state), {}, {
          _owners: action.museums
        });
      }

    default:
      return state;
  }
};

var headerReducer = redux.combineReducers({
  user: userReducer,
  app: appReducer,
  museums: museumsReducer,
  auths: authsReducer,
  authz: authzReducer,
  owner: ownerReducer
});

var Authenticator = function Authenticator(_ref) {
  var appId = _ref.appId,
      app = _ref.app,
      children = _ref.children;
  var loggedIn = reactRedux.useSelector(function (state) {
    return state.header.auths.loggedIn;
  });
  var appLoaded = reactRedux.useSelector(function (state) {
    return state.header.app.loaded;
  });
  var dispatch = reactRedux.useDispatch();
  var loginInProgress = reactRouterDom.useRouteMatch({
    path: '/oauth2/callback',
    exact: true
  }) || reactRouterDom.useRouteMatch({
    path: '/login',
    exact: true
  });
  React.useEffect(function () {
    if (!loggedIn && !loginInProgress) {
      dispatch(refreshToken());
    }
  }, [dispatch, loggedIn, loginInProgress]);
  React.useEffect(function () {
    if (appId) {
      dispatch(setAppInfo(app));
      dispatch(fetchApplication(appId));
    }
  }, [dispatch, appId, app]);
  React.useEffect(function () {
    if (loggedIn) {
      dispatch(fetchAppsNavData(appId));
    }
  }, [loggedIn, appId]);

  if (appLoaded || !appId) {
    return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, children);
  } else {
    return /*#__PURE__*/React__default['default'].createElement("div", null, "Loading application...");
  }
};

var Login = function Login() {
  var location = reactRouterDom.useLocation();
  var state = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
  var callbackUrl = getRedirectUri();
  setPreviousPath(getPreviousLocation(location));
  setState(state);
  var loginUrl = "".concat(getLoginHost(), "/oauth2/authorize?redirect_uri=").concat(callbackUrl, "&state=").concat(state);
  window.location = loginUrl;
  return null;
};

var getLoginHost = function getLoginHost() {
  if (window._env_ && window._env_.REACT_APP_LOGIN_HOST) {
    return window._env_.REACT_APP_LOGIN_HOST;
  } else if (process.env.REACT_APP_LOGIN_HOST) {
    return process.env.REACT_APP_LOGIN_HOST;
  } else {
    return 'https://beta-login.ekultur.org';
  }
};

var getPreviousLocation = function getPreviousLocation(location) {
  if (location.state && location.state.previousPathname) {
    return filterLocationBlacklist(location.state.previousPathname);
  } else {
    return '/';
  }
};

var filterLocationBlacklist = function filterLocationBlacklist(prevLocation) {
  switch (prevLocation) {
    case '/login':
      return '/';

    case '/logout':
      return '/';

    case '/oauth2/callback':
      return '/';

    default:
      return prevLocation;
  }
};

var Logout = function Logout() {
  var dispatch = reactRedux.useDispatch();
  var abortController = new AbortController();
  var history = reactRouterDom.useHistory();
  React.useEffect(function () {
    fetch("".concat(getApigateway$1(), "/auths/oauth2/logout"), {
      method: 'POST',
      credentials: 'include',
      signal: abortController.signal
    }).then(function () {
      cleanStorage();
      dispatch(logOut());
      history.push('/');
    });
    return function () {
      return abortController.abort();
    };
  }, [abortController, history, dispatch]);
  return null;
};

var getApigateway$1 = function getApigateway() {
  if (window._env_ && window._env_.REACT_APP_API_GATEWAY) {
    return window._env_.REACT_APP_API_GATEWAY;
  } else {
    return process.env.REACT_APP_API_GATEWAY;
  }
};

var Callback = function Callback(_ref) {
  _objectDestructuringEmpty(_ref);

  var dispatch = reactRedux.useDispatch();
  var history = reactRouterDom.useHistory();
  var location = reactRouterDom.useLocation();
  var searchParams = location.search ? querystring.parse(location.search.substr(1)) : {};

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      inProgress = _useState2[0],
      setInProgress = _useState2[1];

  React.useEffect(function () {
    if (searchParams.code && searchParams.state && !inProgress) {
      setInProgress(true);
      var state = getState();

      if (searchParams.state !== state) {
        history.push('/');
      } else if (state) {
        codeToToken({
          code: searchParams.code,
          history: history,
          dispatch: dispatch
        });
      }
    }
  }, [searchParams.code, searchParams.state, history, dispatch]);
  return null;
};

var codeToToken = function codeToToken(_ref2) {
  var code = _ref2.code,
      history = _ref2.history,
      dispatch = _ref2.dispatch;
  var redirectUri = getRedirectUri();
  var data = new URLSearchParams();
  data.append('code', code);
  data.append('grant_type', 'authorization_code');
  data.append('redirect_uri', redirectUri);
  fetch("".concat(getApigateway$2(), "/auths/oauth2/token"), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      'Correlation-Id': v4()
    },
    credentials: 'include',
    body: data
  }).then(function (response) {
    if (response.ok) {
      return response.json();
    } else {
      throw new Error(response.statusText);
    }
  }).then(function (data) {
    dispatch(logIn(data.access_token, data.expires_in));
    var previousPath = getPreviousPath();
    cleanStorage();
    history.push(previousPath);
  })["catch"](function (error) {
    console.log(error);
  });
};

var getApigateway$2 = function getApigateway() {
  if (window._env_ && window._env_.REACT_APP_API_GATEWAY) {
    return window._env_.REACT_APP_API_GATEWAY;
  } else {
    return process.env.REACT_APP_API_GATEWAY;
  }
};

var AuthsRoutes = function AuthsRoutes() {
  return /*#__PURE__*/React__default['default'].createElement(React.Fragment, null, /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Route, {
    exact: true,
    path: "/login"
  }, /*#__PURE__*/React__default['default'].createElement(Login, null)), /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Route, {
    exact: true,
    path: "/logout"
  }, /*#__PURE__*/React__default['default'].createElement(Logout, null)), /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Route, {
    exact: true,
    path: "/oauth2/callback"
  }, /*#__PURE__*/React__default['default'].createElement(Callback, null)));
};

var Page401 = function Page401() {
  var loginInProgress = reactRedux.useSelector(function (state) {
    return state.header.auths.loginInProgress;
  });
  var appLoaded = reactRedux.useSelector(function (state) {
    return state.header.app.loaded;
  });
  var location = reactRouterDom.useLocation();
  var history = reactRouterDom.useHistory();
  React.useEffect(function () {
    if (!loginInProgress && appLoaded) {
      history.push({
        pathname: '/login',
        state: {
          previousPathname: location.pathname
        }
      });
    }
  }, [location.pathname, history, loginInProgress, appLoaded]);
  return null;
};

var PrivateRoute = function PrivateRoute(_ref) {
  var _ref$render = _ref.render,
      _render = _ref$render === void 0 ? null : _ref$render,
      _ref$component = _ref.component,
      component = _ref$component === void 0 ? null : _ref$component,
      _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$allowAll = _ref.allowAll,
      allowAll = _ref$allowAll === void 0 ? false : _ref$allowAll,
      rest = _objectWithoutProperties(_ref, ["render", "component", "children", "allowAll"]);

  var loggedIn = reactRedux.useSelector(function (state) {
    return state.header.auths.loggedIn;
  });

  var _useSelector = reactRedux.useSelector(function (state) {
    return state.header.authz;
  }),
      canAccessApp = _useSelector.canAccessApp;

  if (!canAccessApp && !allowAll) {
    return null;
  }

  var childrenOr401 = function childrenOr401() {
    return loggedIn ? children : /*#__PURE__*/React__default['default'].createElement(Page401, null);
  };

  var componentOr401 = function componentOr401() {
    return loggedIn ? component : Page401;
  };

  if (children) {
    return /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Route, rest, childrenOr401());
  }

  if (component) {
    return /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Route, _extends({}, rest, {
      component: componentOr401()
    }));
  }

  if (_render) {
    return /*#__PURE__*/React__default['default'].createElement(reactRouterDom.Route, _extends({}, rest, {
      render: function render(props) {
        return loggedIn === true ? _render(_objectSpread2({}, props)) : /*#__PURE__*/React__default['default'].createElement(Page401, null);
      }
    }));
  }
};

var Header = function Header(_ref) {
  var _ref$mobileOpen = _ref.mobileOpen,
      mobileOpen = _ref$mobileOpen === void 0 ? false : _ref$mobileOpen,
      _ref$mobileOpenHandle = _ref.mobileOpenHandler,
      mobileOpenHandler = _ref$mobileOpenHandle === void 0 ? null : _ref$mobileOpenHandle,
      _ref$translateHandler = _ref.translateHandler,
      translateHandler = _ref$translateHandler === void 0 ? null : _ref$translateHandler,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? null : _ref$className;
  var history = reactRouterDom.useHistory();

  var _useSelector = reactRedux.useSelector(function (state) {
    return state.header;
  }),
      user = _useSelector.user,
      app = _useSelector.app,
      owner = _useSelector.owner,
      auths = _useSelector.auths;

  return /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeader, {
    translateHandler: translateHandler
  }, /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderDrawer, {
    clickHandler: function clickHandler() {
      return mobileOpenHandler(!mobileOpen);
    },
    visible: auths.loggedIn && null !== mobileOpenHandler,
    className: className ? className.hamburger : null
  }), /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderTitleContainer, null, /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderTitle, {
    title: app.title,
    subtitle: null !== owner.name ? owner.name : app.subtitle
  })), /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderAppsNav, {
    visible: auths.loggedIn
  }, /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderApps, {
    apps: user.apps,
    selectAppHandler: function selectAppHandler(url) {
      return window.location.href = url;
    }
  }), /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderMuseums, {
    museums: user.owners,
    selectAppHandler: function selectAppHandler(url) {
      return window.location.href = url;
    },
    preSelectMuseum: owner.uniqueId
  })), /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderUserNav, {
    user: user,
    visible: auths.loggedIn
  }, /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderUserInfo, {
    user: user
  }), /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderAppInfo, {
    app: app
  }), /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderLogout, {
    logoutHandler: function logoutHandler() {
      return history.push('/logout');
    }
  })), /*#__PURE__*/React__default['default'].createElement(appHeader.AppHeaderLogin, {
    visible: !auths.loggedIn,
    loginHandler: function loginHandler() {
      return history.push('/login');
    }
  }));
};

Object.defineProperty(exports, 'kitFetch', {
  enumerable: true,
  get: function () {
    return fetch$1.kitFetch;
  }
});
Object.defineProperty(exports, 'kitFetchExternal', {
  enumerable: true,
  get: function () {
    return fetch$1.kitFetchExternal;
  }
});
Object.defineProperty(exports, 'kitFileUpload', {
  enumerable: true,
  get: function () {
    return fetch$1.kitFileUpload;
  }
});
exports.APPLICATIONS_RECEIVED = APPLICATIONS_RECEIVED;
exports.APPLICATIONS_REQUESTED = APPLICATIONS_REQUESTED;
exports.APPS_NAV_DATA_REQUESTED = APPS_NAV_DATA_REQUESTED;
exports.APP_INFO_SET = APP_INFO_SET;
exports.APP_RECEIVED = APP_RECEIVED;
exports.AUTHZ_DATA_RECEIVED = AUTHZ_DATA_RECEIVED;
exports.Authenticator = Authenticator;
exports.AuthsRoutes = AuthsRoutes;
exports.Callback = Callback;
exports.Header = Header;
exports.Login = Login;
exports.Logout = Logout;
exports.MUSEUMS_FAILED = MUSEUMS_FAILED;
exports.MUSEUMS_RECEIVED = MUSEUMS_RECEIVED;
exports.MUSEUMS_REQUESTED = MUSEUMS_REQUESTED;
exports.OWNER_SELECTED_BY_ID = OWNER_SELECTED_BY_ID;
exports.PrivateRoute = PrivateRoute;
exports.USERDATA_FAILED = USERDATA_FAILED;
exports.USERDATA_RECEIVED = USERDATA_RECEIVED;
exports.USERDATA_REQUESTED = USERDATA_REQUESTED;
exports.USER_LOGGED_IN = USER_LOGGED_IN;
exports.USER_LOGGED_OUT = USER_LOGGED_OUT;
exports.USER_LOGIN_STARTED = USER_LOGIN_STARTED;
exports.applicationsReceived = applicationsReceived;
exports.applicationsRequested = applicationsRequested;
exports.cleanStorage = cleanStorage;
exports.failMuseums = failMuseums;
exports.fetchApplication = fetchApplication;
exports.fetchApplications = fetchApplications;
exports.fetchApplicationsPromise = fetchApplicationsPromise;
exports.fetchAppsNavData = fetchAppsNavData;
exports.fetchMuseums = fetchMuseums;
exports.fetchMuseumsPromise = fetchMuseumsPromise;
exports.fetchUserdataPromise = fetchUserdataPromise;
exports.getPreviousPath = getPreviousPath;
exports.getRedirectUri = getRedirectUri;
exports.getState = getState;
exports.headerReducer = headerReducer;
exports.logIn = logIn;
exports.logOut = logOut;
exports.receiveGlobalApp = receiveGlobalApp;
exports.receiveMuseumApp = receiveMuseumApp;
exports.receiveMuseums = receiveMuseums;
exports.receiveUserdata = receiveUserdata;
exports.refreshToken = refreshToken;
exports.requestMuseums = requestMuseums;
exports.requestUserdata = requestUserdata;
exports.resetUserdata = resetUserdata;
exports.selectOwnerById = selectOwnerById;
exports.setAppInfo = setAppInfo;
exports.setPreviousPath = setPreviousPath;
exports.setState = setState;
//# sourceMappingURL=index.js.map
